import { url } from '@ux/header-util';
import { useRootProps } from '../components/UserDataProvider';
import { TYPES } from './types';

export default function useGetSsoLinks() {
  const { urls, privateLabelId, requestedHeader } = useRootProps();
  let loginLink = urls.sso.login.href;
  let logoutLink = urls.sso.logout.href;
  let createAccountLink = urls.sso.createAccount.href;
  const isInternalSidebar = requestedHeader === TYPES.internal;

  if (privateLabelId === 1 && !isInternalSidebar) {
    const ssoParams = {
      path: '/',
      app: 'venture-redirector'
    };
    loginLink = url.updateQuery(loginLink, ssoParams);
    logoutLink = url.updateQuery(logoutLink, ssoParams);
    createAccountLink = url.updateQuery(createAccountLink, ssoParams);
  }

  if (urls.sso) {
    const { sso } = urls;
    const { path, app } = sso;
    if (path) {
      loginLink = url.updateQuery(loginLink, {
        path
      });
      logoutLink = url.updateQuery(logoutLink, {
        path
      });
      createAccountLink = url.updateQuery(createAccountLink, {
        path
      });
    }
    if (app) {
      loginLink = url.updateQuery(loginLink, {
        app
      });
      logoutLink = url.updateQuery(logoutLink, {
        path
      });
      createAccountLink = url.updateQuery(createAccountLink, {
        app
      });
    }
    if (isInternalSidebar) {
      loginLink = url.updateQuery(loginLink, {
        realm: 'jomax'
      });
      logoutLink = url.updateQuery(logoutLink, {
        realm: 'jomax'
      });
    }
  }

  return {
    createAccountLink,
    loginLink,
    logoutLink
  };
}
